import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;

const { textLObj } = typographyStyles;

export const rootCss = {
  margin: "32px 0 89px",
};

export const ctaContainerCss = {
  display: "flex",
  justifyContent: "center",
  gap: "16px",
  flexFlow: "row wrap",
};

export const messageCss = {
  ...textLObj,
  color: colors.ui.neutral[500],
  lineHeight: "32px",
  maxWidth: "550px",
  marginBotom: "16px",
};

export const anchorCss = {
  padding: "1rem 2rem",
  whiteSpace: "nowrap",
};
